module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 14 Farma Pasa - Rakat (+1).cab82302.mp3";